export const USER_QUESTION_CHARACTER_LIMIT = 250;

export const keyPressMap = { Enter: false, Shift: false };

export const FALLBACK_SESSION_ID = 'fallback-sessionId';
export const FALLBACK_USER_ID = 'fallback-userId';

export const MESSAGE_ORIGIN_PREPOPULATED = 'prepopulated';
export const MESSAGE_ORIGIN_CUSTOM = 'custom';
export const MESSAGE_ORIGIN_UNSPECIFIED = 'unspecified';
export const MESSAGE_ORIGIN_RETRY = 'retry';
